import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/js/wxshare'
import '@/assets/stylus/index.styl'
import '@/assets/fonts/ABChanelCorpo.css'
// import Vconsole from 'vconsole'
// new Vconsole()
Vue.prototype.projectName = '香奈儿5号限定创作系列巡展'
const windowSize = {
		width: document.documentElement.clientWidth,
		height: document.documentElement.clientHeight,
		ratio: window.devicePixelRatio,
		scale: document.documentElement.clientWidth / 375,
	},
	str =
		'width=375, initial-scale=' +
		windowSize.scale +
		', maximum-scale=' +
		windowSize.scale +
		', minimum-scale=' +
		windowSize.scale +
		', user-scalable=no'
document.getElementById('viewport').setAttribute('content', str)

Vue.config.productionTip = false

if (/Android [4-9]/.test(navigator.appVersion)) {
	window.addEventListener('resize', function() {
		if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
			window.setTimeout(function() {
				document.activeElement.scrollIntoViewIfNeeded()
			}, 0)
		}
	})
}

console.log('VERSION:1.0.1')

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
